<div class="flex my-4 gap-8">
	<div class="flex flex-col w-full space-y-8">
		<ng-container *ngIf="mortgage$ | async as mortgage">
			<ui-section title="Registration Details">
				<div section-content>
					<div class="space-y-6">
						<div class="flex flex-row space-x-6">
							<div class="flex flex-1 flex-col space-y-2 w-full max-w-350">
								<span class="text-sm font-normal">Registration Date</span>
								<app-date-picker
									[ngModel]="mortgage?.registrationDate"
									(ngModelChange)="updateRegistrationDate($event)"
								></app-date-picker>
							</div>
							<div class="flex flex-1 flex-col space-y-2 w-full max-w-350">
								<span class="text-sm font-normal">Registration Number</span>
								<app-input
									[ngModel]="mortgage?.registrationNumber"
									(debounce)="updateRegistrationNumber($event)"
								></app-input>
							</div>
						</div>
						<div class="flex w-full flex-col space-y-2">
							<div class="flex flex-row align-middle items-center space-x-2">
								<app-checkbox
									type="clear"
									[ngModel]="mortgage?.assignmentOfRents"
									(ngModelChange)="setAssignmentOfRents($event)"
								></app-checkbox>
								<span class="text-sm font-normal">Assignment of Rents</span>
							</div>
							<div
								class="flex flex-row space-x-6"
								*ngIf="mortgage?.assignmentOfRents"
							>
								<div>
									<span class="text-sm font-normal">Registration Date</span>
									<app-date-picker
										class="max-w-350"
										[ngModel]="mortgage?.assignmentOfRentsRegDate"
										(ngModelChange)="updateAssignmentOfRentsRegDate($event)"
									></app-date-picker>
								</div>
								<div>
									<span class="text-sm font-normal">Registration Number</span>
									<app-input
										class="max-w-350"
										[ngModel]="mortgage?.assignmentOfRentsRegNumber"
										(debounce)="updateAssignmentOfRentsRegNumber($event)"
									></app-input>
								</div>
								<div>
									<span class="text-sm font-normal"
										>PPSA Registration Number</span
									>
									<app-input
										class="max-w-350"
										[ngModel]="mortgage?.assignmentOfRentsPpsaRegNumber"
										(debounce)="updateAssignmentOfRentsPpsaRegNumber($event)"
									></app-input>
								</div>
							</div>
						</div>
						<div class="flex w-full flex-col space-y-2">
							<div
								class="flex w-full flex-row space-x-2 align-middle items-center"
							>
								<app-checkbox
									type="clear"
									[ngModel]="mortgage?.generalSecurityAgreement"
									(ngModelChange)="setGeneralSecurityAgreement($event)"
								></app-checkbox>
								<span class="text-sm font-normal"
									>General Security Agreement</span
								>
							</div>
							<div
								class="flex flex-row space-x-6"
								*ngIf="mortgage?.generalSecurityAgreement"
							>
								<div>
									<span class="text-sm font-normal">Registration Date</span>
									<app-date-picker
										class="max-w-350"
										[ngModel]="mortgage?.generalSecurityAgreementRegDate"
										(ngModelChange)="
											updateGeneralSecurityAgreementRegDate($event)
										"
									></app-date-picker>
								</div>
								<div>
									<span class="text-sm font-normal"
										>GSA Registration Number</span
									>
									<app-input
										class="max-w-350"
										[ngModel]="mortgage?.generalSecurityAgreementRegNumber"
										(debounce)="updateGeneralSecurityAgreementRegNumber($event)"
									></app-input>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ui-section>

			<ui-section title="Fees & Charges">
				<div section-content class="flex flex-col mb-3 gap-6">
					<app-checkbox
						type="clear"
						[ngModel]="mortgage?.hideRegistrationFee"
						(ngModelChange)="setHideRegistrationFee($event)"
					>
						Hide Registration Of Mortgage
					</app-checkbox>
				</div>
			</ui-section>
		</ng-container>
	</div>
</div>
